<div class="breadcrumbs">
    <div class="row">
        <div class="icon breadcrumb-icon fill-black" style="margin-right: 3px; width: 17px; height: 17px;" [inlineSVG]="'assets/ico/star-solid-breadcrumb.svg'"></div>
        <span>Personas </span>
        <div *ngIf="isSection && currentTitle !== 'dashboard.menu.personas.title'">
            <span class="breadcrumb-icon-right"></span>
            <div class="icon breadcrumb-icon fill-black" [inlineSVG]="sectionIcon"></div>
            <span class="text section-title">{{currentTitle | translate}}</span>
        </div>
        
        <div *ngIf="isSubsection">
            <span class="breadcrumb-icon-right"></span>
            <div class="icon breadcrumb-icon fill-black" [inlineSVG]="subsectionIcon"></div>
            <span class="text"> {{currentSubtitle | translate}} </span>
        </div>
    </div>
</div>